// // import { useEffect, useLayoutEffect, useState } from 'react';

// // // material-ui
// // import { useTheme } from '@mui/material/styles';
// // import { Box, Typography, useMediaQuery } from '@mui/material';

// // // project-imports
// // import NavGroup from './NavGroup';
// // import menuItem from 'menu-items';
// // import { DashboardMenu } from 'menu-items/dashboard';

// // import { useSelector } from 'store';
// // import useConfig from 'hooks/useConfig';
// // import { HORIZONTAL_MAX_ITEM } from 'config';

// // // types
// // import { NavItemType } from 'types/menu';
// // import { LAYOUT_CONST } from 'types/config';

// // // ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

// // const Navigation = () => {
// //   const theme = useTheme();

// //   const downLG = useMediaQuery(theme.breakpoints.down('lg'));

// //   const { menuOrientation } = useConfig();
// //   const { drawerOpen } = useSelector((state) => state.menu);

// //   const [selectedItems, setSelectedItems] = useState<string | undefined>('');
// //   const [selectedLevel, setSelectedLevel] = useState<number>(0);
// //   const [menuItems, setMenuItems] = useState<{ items: NavItemType[] }>({ items: [] });

// //   useEffect(() => {
// //     handlerMenuItem();
// //     // eslint-disable-next-line
// //   }, []);

// //   useLayoutEffect(() => {
// //     setMenuItems(menuItem);
// //     // eslint-disable-next-line
// //   }, [menuItem]);

// //   let getDash = DashboardMenu();
// //   const handlerMenuItem = () => {
// //     const isFound = menuItem.items.some((element) => {
// //       if (element.id === 'group-dashboard') {
// //         return true;
// //       }
// //       return false;
// //     });

// //     if (getDash?.id !== undefined && !isFound) {
// //       menuItem.items.splice(0, 0, getDash);
// //       setMenuItems(menuItem);
// //     }
// //   };

// //   const isHorizontal = menuOrientation === LAYOUT_CONST.HORIZONTAL_LAYOUT && !downLG;

// //   const lastItem = isHorizontal ? HORIZONTAL_MAX_ITEM : null;
// //   let lastItemIndex = menuItems.items.length - 1;
// //   let remItems: NavItemType[] = [];
// //   let lastItemId: string;

// //   if (lastItem && lastItem < menuItems.items.length) {
// //     lastItemId = menuItems.items[lastItem - 1].id!;
// //     lastItemIndex = lastItem - 1;
// //     remItems = menuItems.items.slice(lastItem - 1, menuItems.items.length).map((item) => ({
// //       title: item.title,
// //       elements: item.children,
// //       icon: item.icon
// //     }));
// //   }

// //   const navGroups = menuItems.items.slice(0, lastItemIndex + 1).map((item) => {
// //     switch (item.type) {
// //       case 'group':
// //         return (
// //           <NavGroup
// //             key={item.id}
// //             setSelectedItems={setSelectedItems}
// //             setSelectedLevel={setSelectedLevel}
// //             selectedLevel={selectedLevel}
// //             selectedItems={selectedItems}
// //             lastItem={lastItem!}
// //             remItems={remItems}
// //             lastItemId={lastItemId}
// //             item={item}
// //           />
// //         );
// //       default:
// //         return (
// //           <Typography key={item.id} variant="h6" color="error" align="center">
// //             Fix - Navigation Group
// //           </Typography>
// //         );
// //     }
// //   });
// //   return (
// //     <Box
// //       sx={{
// //         pt: drawerOpen ? (isHorizontal ? 0 : 2) : 0,
// //         '& > ul:first-of-type': { mt: 0 },
// //         display: isHorizontal ? { xs: 'block', lg: 'flex' } : 'block'
// //       }}
// //     >
// //       {navGroups}
// //     </Box>
// //   );
// // };

// // export default Navigation;
// import { useEffect, useLayoutEffect, useState, useContext } from 'react';

// // material-ui
// import { useTheme } from '@mui/material/styles';
// import { Box, Typography, useMediaQuery } from '@mui/material';

// // project-imports
// import NavGroup from './NavGroup';
// import menuItem from 'menu-items';
// import { DashboardMenu } from 'menu-items/dashboard';

// import { useSelector } from 'store';
// import useConfig from 'hooks/useConfig';
// import { HORIZONTAL_MAX_ITEM } from 'config';

// // types
// import { NavItemType } from 'types/menu';
// import { LAYOUT_CONST } from 'types/config';

// // permissions
// import JWTContext from 'contexts/JWTContext';
// import { filterMenuByPermissions } from 'menu-items/filterMenu';

// // ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

// const Navigation = () => {
//   const theme = useTheme();
//   const downLG = useMediaQuery(theme.breakpoints.down('lg'));
//   const { menuOrientation } = useConfig();
//   const { drawerOpen } = useSelector((state) => state.menu);

//   const [selectedItems, setSelectedItems] = useState<string | undefined>('');
//   const [selectedLevel, setSelectedLevel] = useState<number>(0);
//   const [menuItems, setMenuItems] = useState<{ items: NavItemType[] }>({ items: [] });

//   // Get logged in user & permissions
//   const { user } = useContext(JWTContext);
//   const userPermissions = user?.permissions || [];

//   useEffect(() => {
//     handlerMenuItem();
//     // eslint-disable-next-line
//   }, []);

//   useLayoutEffect(() => {
//     setMenuItems(menuItem);
//     // eslint-disable-next-line
//   }, [menuItem]);

//   let getDash = DashboardMenu();

//   const handlerMenuItem = () => {
//     const isFound = menuItem.items.some((element) => element.id === 'group-dashboard');

//     if (getDash?.id !== undefined && !isFound) {
//       menuItem.items.splice(0, 0, getDash);
//       setMenuItems(menuItem);
//     }
//   };

//   const isHorizontal = menuOrientation === LAYOUT_CONST.HORIZONTAL_LAYOUT && !downLG;

//   const lastItem = isHorizontal ? HORIZONTAL_MAX_ITEM : null;
//   let lastItemIndex = menuItems.items.length - 1;
//   let remItems: NavItemType[] = [];
//   let lastItemId: string;

//   if (lastItem && lastItem < menuItems.items.length) {
//     lastItemId = menuItems.items[lastItem - 1].id!;
//     lastItemIndex = lastItem - 1;
//     remItems = menuItems.items.slice(lastItem - 1, menuItems.items.length).map((item) => ({
//       title: item.title,
//       elements: item.children,
//       icon: item.icon
//     }));
//   }

//   // ⭐ APPLY PERMISSION FILTERING HERE ⭐
//   const filteredItems = filterMenuByPermissions(menuItems.items, userPermissions);

//   const navGroups = filteredItems.slice(0, lastItemIndex + 1).map((item) => {
//     switch (item.type) {
//       case 'group':
//         return (
//           <NavGroup
//             key={item.id}
//             setSelectedItems={setSelectedItems}
//             setSelectedLevel={setSelectedLevel}
//             selectedLevel={selectedLevel}
//             selectedItems={selectedItems}
//             lastItem={lastItem!}
//             remItems={remItems}
//             lastItemId={lastItemId}
//             item={item}
//           />
//         );
//       default:
//         return (
//           <Typography key={item.id} variant="h6" color="error" align="center">
//             Fix - Navigation Group
//           </Typography>
//         );
//     }
//   });

//   return (
//     <Box
//       sx={{
//         pt: drawerOpen ? (isHorizontal ? 0 : 2) : 0,
//         '& > ul:first-of-type': { mt: 0 },
//         display: isHorizontal ? { xs: 'block', lg: 'flex' } : 'block'
//       }}
//     >
//       {navGroups}
//     </Box>
//   );
// };

// export default Navigation;

import { Box, List } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import useMenuItems from 'menu-items';

// types
// import { NavItemType } from 'types/menu';

const Navigation = () => {
  const menuList = useMenuItems(); // CALL HOOK DIRECTLY HERE

  return (
    <Box sx={{ pt: 2 }}>
      <List
        component="div"
        sx={{
          width: '100%',
          maxWidth: 360,
          paddingTop: 0,
          paddingBottom: 0
        }}
      >
        {menuList.items.map((item) => (
          <NavGroup
            key={item.id}
            item={item}
            lastItem={0}
            remItems={[]}
            lastItemId=""
            selectedItems=""
            setSelectedItems={() => { }}
            selectedLevel={0}               // ⭐ FIXED
            setSelectedLevel={() => { }}     // ⭐ FIXED
          />
        ))}
      </List>
    </Box>
  );
};

export default Navigation;
